export default function CustomSortFunc(a, b) {
  const aSanitized = a.name ? a.name : '';
  const bSanitized = b.name ? b.name : '';
  const aLastName = aSanitized.trim().split(' ').pop();
  const bLastName = bSanitized.trim().split(' ').pop();
  return aLastName > bLastName ? 1 : -1;
}
